<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <DeviceDetails
        v-if="!isAndroid"
        :handleValueChange="handleValueChange"
        :parentType="parentType"
      />
      <SystemInsights
        v-if="showSystemInsights && !isAndroid"
        :class="$style.systemInsights"
        :item="item"
      />
      <SystemSettings
        v-if="isLinux"
        :handleValueChange="handleValueChange"
        :parentType="parentType"
      />
      <AndroidDeviceDetails
        v-if="isAndroid"
        :item="item"
      />
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapGetters } from 'vuex';
import AndroidDeviceDetails from 'client/systems/AndroidDeviceDetails.vue';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import DeviceDetails from 'client/systems/DeviceDetails.vue';
import SystemInsights from 'client/systems/systemInsights/SystemInsights.vue';
import SystemSettings from 'client/systems/SystemSettings.vue';

const storeModel = StoreModelMap[ItemTypeConsts.system];

export default {
  name: 'SystemDetailsWrap',

  inject: ['$validator'],

  components: {
    AndroidDeviceDetails,
    DetailsAsideLayout,
    DeviceDetails,
    SystemInsights,
    SystemSettings,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  computed: {
    ...mapGetters(storeModel, [
      'isAndroid',
      'isLinux',
      'showSystemInsights',
    ]),
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  methods: {
    handleValueChange(value, key) {
      this.setItemField({ key, value });
    },
  },
};
</script>

<style module>
.systemInsights {
  margin: 10px 0 20px;
  overflow: visible !important;
}
</style>
